import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Seo from "../components/Seo";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { api, sized, srcSet } from "../lib/api";
import { useContent } from "../context/ContentContext";

export default function Stories() {
  const { p } = useContent();
  const c = p("stories").header;
  const [stories, setStories] = useState([]);
  useEffect(() => { api.get("/stories").then((r) => setStories(r.data)); }, []);

  const [lead, ...rest] = stories;

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14" data-testid="stories-page">
      <Seo title="Stories — CaminoSapiens" description="Reflections from the road — on walking, waiting, noticing, and the lessons that show up on the trail and after." />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Stories" }]} />
      <div className="max-w-2xl mb-16">
        <p className="overline mb-4">{c.eyebrow}</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-tight">{c.heading}</h1>
        <p className="text-[#4A4947] mt-6 leading-relaxed">{c.body}</p>
      </div>

      {lead && (
        <Link to={`/stories/${lead.slug}`} className="group grid lg:grid-cols-2 gap-8 mb-20 items-center" data-testid={`story-lead-${lead.slug}`}>
          <div className="overflow-hidden border border-[#E4E1DB]">
            <img src={sized(lead.hero_image, 1200)} srcSet={srcSet(lead.hero_image, [600, 1000, 1400])} sizes="(min-width:1024px) 50vw, 100vw" alt={lead.hero_alt || lead.title} className="w-full h-[440px] object-cover transition-transform duration-1000 group-hover:scale-105" />
          </div>
          <div>
            <p className="overline">{lead.published_at} · {lead.author}</p>
            <h2 className="font-display text-4xl mt-3 leading-tight">{lead.title}</h2>
            <p className="text-[#4A4947] mt-4 leading-relaxed">{lead.excerpt}</p>
            <span className="link-underline text-sm mt-4 inline-block">{c.read_more_label}</span>
          </div>
        </Link>
      )}

      <div className="grid md:grid-cols-3 gap-x-8 gap-y-14">
        {rest.map((s, i) => (
          <motion.div key={s.id} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}>
            <Link to={`/stories/${s.slug}`} className="group block" data-testid={`story-${s.slug}`}>
              <div className="overflow-hidden border border-[#E4E1DB]">
                <img src={sized(s.hero_image, 900)} srcSet={srcSet(s.hero_image)} sizes="(min-width:768px) 33vw, 100vw" alt={s.hero_alt || s.title} className="w-full h-64 object-cover transition-transform duration-1000 group-hover:scale-105" loading="lazy" />
              </div>
              <p className="overline mt-4">{s.published_at}</p>
              <h3 className="font-display text-2xl mt-1 leading-tight">{s.title}</h3>
              <p className="text-sm text-[#4A4947] mt-2 line-clamp-3">{s.excerpt}</p>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
